import { render, staticRenderFns } from "./retailList.vue?vue&type=template&id=03669512&scoped=true&"
import script from "./retailList.vue?vue&type=script&lang=js&"
export * from "./retailList.vue?vue&type=script&lang=js&"
import style0 from "./retailList.vue?vue&type=style&index=0&id=03669512&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03669512",
  null
  
)

export default component.exports